// extracted by mini-css-extract-plugin
module.exports = {"circle":"_3_EoeZcY4tTsIoaHGipID6","leftLabel":"_Erj69zOVVJZUmVMmrgH2","rightLabel":"_4iOkxl0AkPltPwCi-jcGF"};